// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'Col',
    mixins: [
        template,
    ]
})
export class Col extends Vue {

    public get colClasses() {

        const classes: string[] = []
        const breakPoints = ['sm', 'md', 'lg', 'xl']
        const offsetPoints = ['offset', 'offsetSm', 'offsetMd', 'offsetLg', 'offsetXl']

        for (let key in this.$props) {

            if (key === 'col') {

                if (this.$props[key] === '') {
                    classes.push('col')
                } else if (typeof this.$props[key] === 'number') {
                    classes.push(`col-${this.$props[key]}`)
                }
            } else if (breakPoints.includes(key)) {

                if (this.$props[key] === '') {
                    classes.push(`col-${key}`)
                } else if (typeof this.$props[key] === 'number') {
                    classes.push(`col-${key}-${this.$props[key]}`)
                }
            } else if (offsetPoints.includes(key) && this.$props[key]) {

                let offsetBreakpointName = key.substr(6)

                if (offsetBreakpointName === '') {
                    classes.push(`offset-${this.$props[key]}`)
                } else {
                    classes.push(`offset-${offsetBreakpointName.toLowerCase()}-${this.$props[key]}`)
                }
            } else if ((key === 'align' || key === 'justify') && this.$props[key]) {
                classes.push(`${key}-${this.$props[key]}`)
            } else if (key === 'no-gutters' && this.$props[key]) {
                classes.push('no-gutters')
            } else if (key === 'order' && this.$props[key]) {
                classes.push(`${key}-${this.$props[key]}`)
            }
        }

        if (!classes.length) {
            classes.push('col')
        }

        return classes
    }

    @Prop([Number, String])
    public col?: number

    @Prop([Number, String])
    public sm?: number

    @Prop([Number, String])
    public md?: number

    @Prop([Number, String])
    public lg?: number

    @Prop([Number, String])
    public xl?: number

    @Prop()
    public offset?: number

    @Prop()
    public offsetSm?: number

    @Prop()
    public offsetMd?: number

    @Prop()
    public offsetLg?: number

    @Prop()
    public offsetXl?: number

    @Prop()
    public align?: string

    @Prop()
    public justify?: string

    @Prop()
    public noGutters?: boolean

    @Prop([Number, String])
    public order?: number
    
    public created () {

    }
}